var common = require("../../utiles/common");
function viewModelDD(params) {
  var $this = this;
  $this.openCode = function () {
    var state = sessionStorage.getItem("state")
      ? sessionStorage.getItem("state")
      : "";
    var data = common.fetch(params.baseUrl + params.url, {
      type: "GET",
      query: { state: state },
    });
    if (window.DTFrameLogin) {
      window.DTFrameLogin(
        {
          id: "dd-qrcode-container",
          width: 300,
          height: 300,
        },
        {
          redirect_uri: data.redirect_uri,
          client_id: data.client_id,
          scope: data.scope,
          response_type: "code",
          state: data.state,
          prompt: data.prompt,
        },
        function (loginResult) {
          // 这里可以直接进行重定向
          window.location.href = loginResult.redirectUrl+"&appid="+data.appid;
          // 也可以在不跳转页面的情况下，使用code进行授权
          console.log(loginResult.authCode);
        },
          function(errorMsg){
          // 这里一般需要展示登录失败的具体原因
          alert("Login Error: "+errorMsg);
        }
      );
    }
  };
  setTimeout(function () {
    $this.openCode();
  }, 200);
}
// 组件销毁时循环函数设置为undefined
viewModelDD.prototype.dispose = function () {
  this.qrLoop = undefined;
};

module.exports = {
  register: function () {
    document.createElement("dd-login");
    ko.components.register("dd-login", {
      viewModel: viewModelDD,
      template: require("./DDLogin.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/template/ddLogin/DDLogin.js
// module id = 111
// module chunks = 0